import rhinoBlue from 'rhino/src/core/blue/blue.module';

import * as rnClient from './client.provider';

export default angular.module('rhino.core.client', [
  rhinoBlue,
])
  .provider(rnClient.name, rnClient.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/client/client.module.js